import { Container, styled } from "@mui/material"

export const StyledLayoutBox = styled(Container)(({ theme }) => ({
  width: "100%",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(8)
}))
